import { isRecord } from './object';

/**
 * Whether the request never completed. ofetch names every failure `FetchError` and only attaches a
 * `response` once one arrived, so its absence covers a refused connection, a DNS failure and the
 * `FETCH_TIMEOUT_MS` abort alike.
 */
export function isConnectionFailure(error: unknown): boolean {
	return isRecord(error) && error.name === 'FetchError' && error.response == null;
}
